const translations = {
    active: 'Active',
    all: 'All',
    allCustomers: 'All Customers',
    backToJobs: 'Back to jobs',
    calendar: 'Calendar',
    calendarLegend: 'Legend',
    canceled: 'Canceled',
    complete: 'Complete',
    contents: 'Job Contents',
    countItems: '{count} items',
    day: 'Day',
    drawerSummaryFlights: 'flights',
    drawerSummaryMaps: 'maps',
    drawerSummaryPurs: 'PURs',
    drawerSummaryWorkOrder: 'WO',
    eventsToday: '{count} events today',
    fetchFailed: 'Unable to load jobs',
    flightGroupFallbackTitle: 'Flight Group',
    flightGroupTitlePrefix: 'Flight Group',
    flightSourceCsv: 'CSV',
    flightSourceKml: 'KML',
    flightSourceSynced: 'Synced',
    flightTitlePrefix: 'Flight',
    flights: 'Flights',
    flightsCountSuffix: 'flights',
    jobs: 'Jobs',
    legendFlights: 'Flights',
    legendJobs: 'Jobs / Work Orders',
    legendMaps: 'Maps',
    legendPending: 'Pending',
    legendUsageReports: 'Usage Reports',
    loading: 'Loading jobs…',
    map: 'Map',
    mapTypeAam: 'Application Map',
    mapTypeAsFlown: 'As-Flown',
    mapTypeCoverage: 'Coverage',
    mapTypeDryCoverage: 'Dry Coverage',
    mapTypePillAam: 'AAM',
    mapTypePillAsFlown: 'As-Flown',
    mapTypePillCoverage: 'Covered',
    mapTypePillDryCoverage: 'Dry',
    mapTypePillSprayByArea: 'Spray',
    mapTypeSprayByArea: 'Spray by Area',
    maps: 'Maps',
    month: 'Month',
    noJobs: 'No jobs to show',
    noJobsDescription: 'Try adjusting your filters or search.',
    pending: 'Pending',
    purFallbackTitle: 'Product Usage Report',
    purTitlePrefix: 'PUR',
    scheduled: 'Scheduled',
    searchPlaceholder: 'Search jobs…',
    started: 'Started',
    statsActive: 'Active',
    statsComplete: 'Complete',
    statsPending: 'Pending',
    statsTotal: 'Total',
    today: 'Today',
    totalSuffix: 'total',
    usageReports: 'Usage Reports',
    week: 'Week',
    workOrder: 'Work Order',
    workOrderFallbackTitle: 'Work Order'
};

export default translations;
